module.exports = __webpack_public_path__ + "img/wheres-chloe-book.302a2eaa.jpg";